export const getPriceChangedInfo = (changeAmount: number | null): { sign: string; color: string } | null => {
  if (changeAmount === null) {
    return null;
  }

  switch (Math.sign(changeAmount)) {
    case 1:
      return { sign: '+', color: '#ff3049' };
    case -1:
      return { sign: '-', color: '#196EFF' };
    default:
      return { sign: '±', color: '#858894' };
  }
};
